import { render, staticRenderFns } from "./CommentIcon.vue?vue&type=template&id=91ea425e&scoped=true"
import script from "./CommentIcon.vue?vue&type=script&lang=js"
export * from "./CommentIcon.vue?vue&type=script&lang=js"
import style0 from "./CommentIcon.vue?vue&type=style&index=0&id=91ea425e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ea425e",
  null
  
)

export default component.exports